import React, { useEffect, useState } from 'react';
import { CircularProgress, Typography } from '@material-ui/core';
import moment from 'moment';
import './styles.scss';
import { Modal } from 'react-bootstrap';
import { useParams } from 'react-router-dom';
import useGetDeliveryEvents from '../../../../hooks/delivery-events/useGetDeliveryEvents';
import useGetCart from '../../../../hooks/carts/useGetCart';
import CustomizedTimeline, { TimeLineEvent } from '../../../TimeLine/Timeline';
import { CartStatus, ReceiptStatus } from '../../../../types/drawer.types';
import colors from '../../../../assets/styles/colors';

interface HistoricProps {
  cartId: string;
  isOpen: boolean;
  setShowHistory: (isOpen: false) => void;
}
const Historic: React.FC<HistoricProps> = ({
  cartId,
  isOpen,
  setShowHistory,
}) => {
  const { id } = useParams<{ id?: string }>();
  const { execute, loading } = useGetDeliveryEvents();
  const { execute: getCart, loading: loadingDelivery } = useGetCart();
  const [deliveryEvents, setDeliveryEvents] = useState<TimeLineEvent[]>([]);

  useEffect(() => {
    const fetchHistoricData = async () => {
      if (!cartId) return;
      try {
        const data = await getCart({ cartId, freightId: id });
        if (!data) return;
        const events = await execute({ cartId });
        if (events) {
          const filteredData = events
            .sort(
              (a, b) =>
                new Date(a.timestamp).getTime() -
                new Date(b.timestamp).getTime(),
            )
            .map((event: any) => {
              switch (event.status) {
                case ReceiptStatus.APPROVED:
                  return {
                    time: moment(event.timestamp).format('DD/MM/yyyy HH:mm'),
                    img:
                      data?.receipt.images.find(
                        el => el.receiptImageId === event.receiptImageId,
                      )?.urlMain || '',
                    content: data?.receipt.status ? undefined : 'Aguardando',
                    dotColor: data?.receipt ? 'green' : 'grey',
                  };
                case CartStatus.ARRIVED_DELIVERY_ADDRESS:
                  return {
                    time: moment(event.timestamp).format('DD/MM/yyyy HH:mm'),
                    content: `${event.status}`,
                    dotColor: colors.primary.orange,
                  };
                case CartStatus.PROBLEM_REPORTED:
                  return {
                    time: moment(event.timestamp).format('DD/MM/yyyy HH:mm'),
                    content: (
                      <Typography>
                        Descrição: {event.problemDescription}
                      </Typography>
                    ),
                    dotColor: colors.error.richRed,
                  };
                default:
                  return {
                    time: moment
                      .utc(event.timestamp)
                      .local()
                      .format('DD/MM/yyyy HH:mm'),
                    content: `${event.status}`,
                    dotColor: colors.primary.orange,
                  };
              }
            })
            .filter(event => event !== undefined);

          setDeliveryEvents(filteredData);
        }
      } catch (error) {
        console.error(error);
      }
    };
    fetchHistoricData();
  }, [cartId]);
  return (
    <Modal
      centered
      onHide={() => setShowHistory(false)}
      style={{
        display: 'flex',
        justifyContent: 'center',
        alignContent: 'center',
      }}
      size="lg"
      show={isOpen}
    >
      <Modal.Body>
        <div className="container-historic">
          {loading ? (
            <CircularProgress />
          ) : (
            <div>
              <div>
                <CustomizedTimeline timelineData={deliveryEvents} />
              </div>
            </div>
          )}
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default Historic;
